import React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-left">
          <span className="footer-brand">WETWARE</span>
          <span className="footer-divider">/</span>
          <span className="footer-year">{currentYear}</span>
        </div>

        <div className="footer-center">
          <a href="mailto:admin@wetware.ai" className="footer-email">
            ADMIN@WETWARE.AI
          </a>
        </div>

        <div className="footer-right">
          <span className="footer-status">
            <span className="status-dot" />
            OPERATIONAL
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
